import React, {useState, useEffect} from 'react'
import PageApp from '../Page';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Label from '@app/components/General/Label'
import { Button, Row, Col, Input, message, Select } from 'antd';
import {login, getAllCompanies} from '../../apis/AuthApi';
import {setToken} from '../../apis/Tools';
import authAction from '@app/redux/auth/actions';
import {MenuFoldOutlined, MenuUnfoldOutlined, CaretDownOutlined } from '@ant-design/icons';

const HomePage = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const authState = useSelector((state) => state.Auth);
    const routes = [];
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [selectedCompany, setSelectedCompany] = useState('1');
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        const fetchCompanies = async () => {
          try {
            const response = await getAllCompanies();
            
            if (response.ok && response.payload.length > 0) {
                const formattedCompanies = response.payload.map(company => ({
                    value: company.id, // Usamos el ID interno como valor
                    label: company.name, // Mostramos el nombre
                }));
              
                setCompanies(formattedCompanies);
                setSelectedCompany(formattedCompanies[0].value); // Selecciona la primera por defecto
            }
          } catch (error) {
            console.error("Error cargando compañías:", error);
          } finally {
          }
        };
    
        fetchCompanies();
    }, []);

    const handleOk = async () => {
        const payload = {
            email,
            password,
        }
        const response = await login(payload);
        if(response.ok){
            message.success('Se encuentra logueado!');
            setToken(response.payload.token, {...response.payload});
            dispatch(authAction.login(response));
        }
    }

    const handleCompanyChange = (value) => {
        setSelectedCompany(value);
    };

     React.useEffect(() => {
          if (authState.isLoggedIn){
              return navigate("/home");
          }
      },[authState.isLoggedIn]);

    return <PageApp routes={routes}>
            <div>Login!</div>
            <Row style={{maxWidth: 300}}>
                <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                    <Label>Correo Electrónico</Label>
                    <Input value={email} defaultValue={email} onChange={(event)=>{setEmail(event.target.value)}} size="middle"/>
                </Col>
                <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                    <Label>Password</Label>
                    <Input.Password value={password} defaultValue={password} onChange={(event)=>{setPassword(event.target.value)}} size="middle"/>
                </Col>
                <Col md={{span: 22, offset: 1}} sm={{span: 22, offset: 1}} xs={{span: 22, offset: 1}}>
                    <Label>Password</Label>
                    <Select
                        value={selectedCompany}
                        onChange={handleCompanyChange}
                        options={companies}
                        style={{ width: 220 }}
                        suffixIcon={<CaretDownOutlined />}
                    />
                </Col>
            </Row>
            <br/>
            <Button key="submit" type="primary" onClick={handleOk}>
                Enviar
            </Button>
        </PageApp>
    };

export default HomePage;